module.exports = __webpack_public_path__ + "static/media/edna.63f205c4.png";